import { getMessageMinimumDetails } from 'Api/beMessApi'
import { getRecipient } from 'Api/beRecipientApi'
import { getRecipientEventsClicks } from 'Api/beStatisticsApi'
import {
  STORE_KEY_ID_LIST,
  STORE_KEY_LIST,
  fromUTCtoZoneFormatted,
  storeGet,
} from 'mailup-react-helpers'

export async function getMessageMinimumDetailsAction(idMessage) {
  const resp = await getMessageMinimumDetails(idMessage)
  return resp
}

export async function getRecipientAction(idRecipient) {
  const resp = await getRecipient(idRecipient)
  return resp
}

export async function getRecipientEventsClicksAction(
  idRecipient,
  pagesize,
  pagenumber,
  orderby,
  orderdescending,
) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const { TimeZoneCode } = storeGet(STORE_KEY_LIST)
  const resp = await getRecipientEventsClicks(
    idList,
    idRecipient,
    pagesize,
    pagenumber,
    orderby,
    orderdescending,
  )

  if (resp.Clicks.EventList) {
    resp.Clicks.EventList.forEach((i) => {
      if (i.EventDate) {
        const date = new Date(i.EventDate)
        i.EventDate = fromUTCtoZoneFormatted(
          date,
          TimeZoneCode,
          'YYYY-MM-DD HH:mm',
        )
      }
    })
  }

  return resp
}
